import React from 'react';
import { ArchDivider } from '../brand/Jaipur';
import { Eyebrow } from './shared';
import './home.css';

const STEPS = [
  { title: 'Listen', text: 'A proper sit-down on your brand, your customers and what’s not working yet.', color: 'bg-apn-orange text-neutral-950' },
  { title: 'Shape', text: 'One clear plan: what to say, where to show up and how we’ll measure it.', color: 'bg-apn-pink text-neutral-950' },
  { title: 'Build & launch', text: 'Content, design, site and ads made in-house and shipped on schedule.', color: 'bg-apn-saffron text-neutral-950' },
  { title: 'Refine & grow', text: 'We read the numbers every week and double down on what works.', color: 'bg-apn-bg text-apn-ink' },
];

export default function HowWeWork() {
  return (
    <section aria-labelledby="home-process-title" className="bg-apn-ink text-apn-bg">
      <ArchDivider className="rotate-180 text-apn-bg" />
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8 short:py-10">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <Eyebrow className="!text-apn-saffron">How we work</Eyebrow>
            <h2 id="home-process-title" data-animate="split-heading" className="mt-3 font-display text-3xl font-extrabold leading-[1] tracking-[-0.03em] sm:text-4xl lg:text-5xl">
              Four steps. No fluff.
            </h2>
          </div>
        </div>
        <ol data-animate="stagger" className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-4 lg:gap-0">
          {STEPS.map((step, i) => (
            <li key={step.title} className="relative rounded-2xl border home-border-soft p-5 lg:rounded-none lg:border-0 lg:border-l lg:px-6 lg:py-2 lg:first:border-l-0 lg:first:pl-0">
              <div className="flex items-center gap-3">
                <span aria-hidden="true" className={`flex h-10 w-10 items-center justify-center rounded-full font-display text-lg font-extrabold ${step.color}`}>
                  {i + 1}
                </span>
                <h3 className="font-display text-2xl font-extrabold tracking-[-0.02em]">
                  <span className="sr-only">Step {i + 1}: </span>
                  {step.title}
                </h3>
              </div>
              <p className="mt-3 text-base leading-relaxed opacity-80">{step.text}</p>
            </li>
          ))}
        </ol>
      </div>
      <ArchDivider className="text-apn-bg" />
    </section>
  );
}
